import { GridColumnConfig } from "../../../../models/gridCoumnConfig";

export const columns: GridColumnConfig[] = [
  {
    title: 'Proctor File Name',
    field: 'proctorFileName',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  {
    title: 'Proctor Date',
    field: 'proctorDate',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Proctor File Number',
    field: 'fileNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Dry Density',
    field: 'dryDensity',
    filter: 'numeric',
    searchable: true,
  },
  {
    title: 'Optimum Moisture Content',
    field: 'optimumMoistureContent',
    filter: 'numeric',
    searchable: true,
  },
  {
    title: 'Visual Soil Characteristics',
    field: 'visualSoilCharacteristics',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded File Name',
    field: 'uploadedFileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Updated On',
    field: 'updatedOn',
    filter: 'text',
    searchable: true,
  },
];
